import type { TelemetryEvent } from '../../events';
import { isAnalyticsEvent, isAnalyticsV2Event } from '../../events';

export const addVisibilityStateToLogEvent = async (event: TelemetryEvent): Promise<TelemetryEvent> =>
  isAnalyticsEvent(event) || isAnalyticsV2Event(event)
    ? event
    : {
        ...event,
        properties: {
          ...event.properties,
          visibilityState: document.visibilityState,
        },
      };
